import React from "react";

import { menu } from "../../header/navigation/data/menu";
import SchoolFooterColumn from "./SchoolFooterColumn";

import "./SchoolFooterLinks.css";

const SchoolFooterLinks = () => {
  const footerMenu = [...menu]
    .filter((item) => item.showInFooter)
    .sort((a, b) => a.footerOrder - b.footerOrder);

  return (
    <>
      {footerMenu.map((item) => (
        <SchoolFooterColumn
          key={item.id}
          item={item}
        />
      ))}
    </>
  );
};

export default SchoolFooterLinks;

